import script from "./uploadSrt.vue?vue&type=script&setup=true&lang=ts"
export * from "./uploadSrt.vue?vue&type=script&setup=true&lang=ts"

import "./uploadSrt.vue?vue&type=style&index=0&id=341afc3e&scoped=true&lang=scss"
import "./uploadSrt.vue?vue&type=style&index=1&id=341afc3e&scoped=true&lang=css"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341afc3e"]])

export default __exports__